import React, { useState } from 'react';
import emailjs from 'emailjs-com';
import { CheckCircle } from 'lucide-react';
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

const ContactForm = () => {
  const Service_Ids = process.env.REACT_APP_Service_Id;
  const Template_Ids = process.env.REACT_APP_Template_Id;
  const Public_Keys = process.env.REACT_APP_Public_Key;

  const [formdata, setFormData] = useState({
    CompanyName: "",
    Name: "",
    DialCode: "",
    Phone: "",
    Email: "",
    Message: ""
  });

  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formdata, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    fetch("https://script.google.com/macros/s/AKfycbw5vBmaVavmo4nzIw7u-2DgHFeC-_iwWX8i-_ygQi3vfotSiilAXqkj9534Im8pUQfmlA/exec", {
  method: "POST",
  body: JSON.stringify({
    companyname: formdata.CompanyName,
    name: formdata.Name,
    dialcode:formdata.DialCode,
    phone: formdata.Phone,
    email: formdata.Email,
    message: formdata.Message
  })
});

    emailjs.send(Service_Ids, Template_Ids, {
      companyname: formdata.CompanyName,
      name: formdata.Name,
      dialcode:formdata.DialCode,
      phone: formdata.Phone,
      email: formdata.Email,
      message: formdata.Message
    }, Public_Keys)
    .then(() => {
      setLoading(false);
      setSubmitted(true);
    })
    .catch((err) => {
      setLoading(false);
      console.error(err);
      alert("Something went wrong ❌");
    });
  };

  // ── Success Screen ──
  if (submitted) {
    return (
      <div className="flex flex-col items-center justify-center text-center py-10">
        <div className="flex items-center justify-center mb-4">
          <CheckCircle className="text-green-600 w-20 h-20" />
        </div>
        <h3 className="text-[1.6rem] font-bold text-gray-900 mb-1">Thank You!</h3>
        <p className="text-gray-700 text-md">Your form has been submitted successfully.</p>
        <p className="text-gray-700 text-md">We will respond to you within 24-48 hr</p>
      </div>
    );
  }

  // ── Form Screen ──
  return (
    <>
      <div className="mb-2">
        <h3 className="text-4xl text-center font-bold text-gray-900 mb-2">
          Get in <span className="text-blue-600">Touch</span>
        </h3>
        <p className="text-gray-600 text-center mb-8">
          We will respond to your message as soon as possible
        </p>
      </div>

      <form className="space-y-6 w-full" onSubmit={handleSubmit}>
        <div className="grid md:grid-cols-2 gap-6">
          <input type="text" name="CompanyName" onChange={handleChange} placeholder="Company Name" required className="bg-gray-100 border-0 h-12 px-4 rounded-md placeholder:text-gray-500" />
          <input type="text" name="Name" onChange={handleChange} placeholder="Your Name" required className="bg-gray-100 border-0 h-12 px-4 rounded-md placeholder:text-gray-500" />
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          
        <PhoneInput
  country="in"
  value={formdata.DialCode + formdata.Phone}
  enableSearch={true}
  countryCodeEditable={false}
  placeholder="Your Phone"
  inputProps={{
    name: "Phone",
    required: true,
  }}
  onChange={(value, country) => {
    const dialCode = `+${country.dialCode}`;

    const phone = value
      .replace(country.dialCode, "")
      .replace(/\D/g, "");

    setFormData((prev) => ({
      ...prev,
      DialCode: dialCode,
      Phone: phone,
    }));
  }}
  containerClass="w-full"
  inputClass="!w-full !h-12 !bg-gray-100 !border-0 !rounded-md"
  buttonClass="!bg-gray-100 !border-0 !rounded-l-md"
/>
          <input type="email" name="Email" onChange={handleChange} placeholder="Your Email" required className="bg-gray-100 border-0 h-12 px-4 rounded-md placeholder:text-gray-500" />
        </div>
        <textarea name="Message" onChange={handleChange} placeholder="Type Your Message..." className="bg-gray-100 border-0 px-4 py-3 rounded-md min-h-[120px] placeholder:text-gray-500 resize-none w-full" />
        <button type="submit" disabled={loading} className="bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3 h-12 w-full rounded-lg transition">
          {loading ? "Sending..." : "Send a message"}
        </button>
      </form>
    </>
  );
};

export default ContactForm;